import { Col, Flex, notification, Row } from "antd";

import { useEffect } from "react";
import { useProjectsInfo } from "projects/queries";
import { OperationsManagerDashboardInstallationsCard } from "./operations-manager-dashboard-installations-card/OperationsManagerDashboardInstallationsCard";
import { OperationsManagerDashboardProjectsCard } from "./operations-manager-dashboard-projects-card/OperationsManagerDashboardProjectsCard";
import variables from "../../../../_variables.scss";
import { SalesTargetTimePeriods } from "users/components";
import { NotesList } from "notes/components";
import { useBoundStore } from "store";

export const OperationsManagerDashboard = () => {
  const { currentOrganization } = useBoundStore();
  const {
    data: projectsInfo,
    isSuccess,
    error,
    refetch,
  } = useProjectsInfo(currentOrganization?.id);
  const [api, notificationContextHolder] = notification.useNotification();

  const onSalesTargetTimePeriodChange = () => {
    refetch();
  };

  useEffect(() => {
    if (error) {
      api.error({
        message: "Error",
        description: (error as Error)?.message,
      });
    }
  }, [error, api]);

  return (
    <Flex vertical gap={variables.largeGap}>
      {notificationContextHolder}
      <Flex>
        <SalesTargetTimePeriods
          name='sales-target-time-periods'
          onChange={onSalesTargetTimePeriodChange}
        />
      </Flex>
      <Row gutter={{ xs: 4, sm: 8, md: 16, lg: 32 }} justify={"space-between"}>
        <Col span={16}>
          <OperationsManagerDashboardInstallationsCard
            loading={!isSuccess}
            installationsRecap={projectsInfo?.installationsRecap}
            installationsBySubcontractor={projectsInfo?.installationsBySubcontractor}
            closeoutsBySubcontractor={projectsInfo?.closeoutsBySubcontractor}
          />
        </Col>
        <Col span={8}>
          <NotesList title={"My Project Notes"} showCard />
        </Col>
      </Row>
      <OperationsManagerDashboardProjectsCard
        loading={!isSuccess}
        deficientProjects={projectsInfo?.deficientProjects}
        projectsInCloseoutStage={projectsInfo?.projectsInCloseoutStage}
      />
    </Flex>
  );
};
